import { formatDate } from '@mys/contracts/format';
import { useProjects } from '../lib/portal.js';

/* ============================================================================
   /files — "code aapka" made checkable.
   ----------------------------------------------------------------------------
   **This screen does not list files, because there are none to list.** There
   is no file model in the schema and no object storage anywhere in this
   product: `EditRequest.attachments` is a `String[]` of storage keys for a
   store that was never built. Rendering an empty "Your files" list would be a
   screen that looks broken and, worse, implies we are holding something back.

   What it does instead is state the promise the public site makes — the code
   and the domain are the client's, and they can have both on request — and
   give them the one action that actually works today: message us. That is a
   true screen, not a placeholder.

   To make it a real file list, the product needs a decision first: where files
   live (R2 or S3), who uploads them, and whether "the code" means a zip, a Git
   repository, or a handover document. That is a client question, not a coding
   one. See CONTEXT.md §14.
   ========================================================================== */

export function FilesPage() {
  const projects = useProjects();
  const items = projects.data?.projects ?? [];
  const live = items.filter((project) => project.liveUrl || project.domain);

  const message = encodeURIComponent(
    'Namaste, mujhe apni site ka code aur domain ka access chahiye.',
  );

  return (
    <>
      <h1 className="h1">Aapka code, aapka domain</h1>

      <section className="card stack">
        <p>
          Jo humne banaya hai woh aapka hai. Code, domain, hosting — sab aapke naam par transfer ho
          sakta hai, kabhi bhi, bina kisi extra charge ke.
        </p>
        <p className="muted">
          Abhi yeh WhatsApp par hota hai: bata dijiye, hum ek din mein bhej denge. Yahan se seedha
          download karne ka option ban raha hai.
        </p>
        <a className="btn" href={`https://wa.me/918630415226?text=${message}`}>
          Code aur access maangiye
        </a>
      </section>

      {live.length > 0 ? (
        <section className="card">
          <p className="kicker">Aapki site</p>
          <ul className="list">
            {live.map((project) => (
              <li key={project.id} className="list__row list__row--static">
                <span>
                  <strong>{project.domain ?? project.plan}</strong>
                  <br />
                  <span className="muted small">
                    {project.launchedAt
                      ? `${formatDate(project.launchedAt)} se live`
                      : 'Abhi ban rahi hai'}
                  </span>
                </span>
                {project.liveUrl ? (
                  <a href={project.liveUrl} target="_blank" rel="noreferrer" className="link">
                    Kholiye
                  </a>
                ) : null}
              </li>
            ))}
          </ul>
        </section>
      ) : null}
    </>
  );
}
